import Chart from "../../../../src/client/katnh/interactions/chart/Chart.js";
import PeriprocedureelBeleidVKAKatnh from "../../../../src/client/katnh/periprocedureel-beleid-vka.json";
import * as React from 'react';
export default {
  Chart,
  PeriprocedureelBeleidVKAKatnh,
  React
};